<div class="step-container">
    <div class="step-content">
        <app-brand-search 
            [firstName]="displayFirstName"
            (continueToNextStep)="onNext()">
        </app-brand-search>
    </div>
</div>
